<template>
  <div v-if="visible" id="job-modal-store">
    <el-dialog v-model="visible" class="dialog-job">
      <el-collapse>
        <JobListItemComponent
          :job="job"
          :open="modalOpen"
          @selected-to-edit="editJob"
          @cancel="cancelJob"
          @duplicate-job="closeModal()"
        />
      </el-collapse>
    </el-dialog>
  </div>
</template>

<script>
import JobListItemComponent from '@/components/MyJobs/JobListItemComponent';
import { mapStores } from 'pinia';
import { useJobModalStore } from '@/stores/jobModal';

export default {
  components: {
    JobListItemComponent,
  },
  computed: {
    ...mapStores(useJobModalStore),
    visible: {
      get() {
        return this.jobModalStore.visible;
      },
      set() {
        this.jobModalStore.close();
      },
    },
    job() {
      return this.jobModalStore.job;
    },
    modalOpen() {
      return this.jobModalStore.expanded;
    },
  },
  methods: {
    closeModal() {
      this.jobModalStore.close();
    },
    editJob(data) {
      this.closeModal();
      this.$bus.editJob(data);
    },
    cancelJob(data) {
      this.closeModal();
      this.$bus.cancelJob(data);
    },
  },
};
</script>
